export default __webpack_public_path__ + "static/media/Roboto-Bold.c7444f8b.ttf";